import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import MapleMarketDetailView from '@/components/maple-market/MapleMarketDetailView';
import { getMapleMarketAppById, type MapleMarketCategory } from '@/data/mapleMarketApps';
import type { MapleMarketInfoPageId } from '@/components/maple-market/MapleMarketInfoView';

export default function MapleMarketAppDetail() {
  const navigate = useNavigate();
  const { appId = '' } = useParams<{ appId: string }>();
  const app = getMapleMarketAppById(appId);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('allow-window-scroll');
    return () => {
      root.classList.remove('allow-window-scroll');
    };
  }, []);

  const handleCategoryChange = (category: MapleMarketCategory | 'All') => {
    navigate(category === 'All' ? '/market' : `/market?category=${encodeURIComponent(category)}`);
  };

  const handleOpenPage = (page: MapleMarketInfoPageId) => {
    navigate(`/market?page=${encodeURIComponent(page)}`);
  };

  return (
    <>
      <SEO
        title={app ? `${app.name} — Maple Market` : 'Maple Market'}
        description={app?.description || 'Browse Maple Market app details and discover new MapleOS experiences.'}
      />
      <MapleMarketDetailView
        appId={appId}
        onOpenPage={handleOpenPage}
        onSelectCategory={handleCategoryChange}
        onSelectApp={(nextAppId) => navigate(`/market/app/${nextAppId}`)}
      />
    </>
  );
}